<template>
    <div>
        <b-card class="card-news-form" header-tag="header" footer-tag="footer">
        <alert-success :redirectName="'101shops-home'" :show="successMessage != ''"> {{ successMessage }} </alert-success>
        <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>
        <!-- for loading page -->
        <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
        <div slot="header">
        <i class="fa fa-list-ul" aria-hidden="true"></i>
            Shop Form
        <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
            <small class="text-muted">docs</small>
            </a>
        </div>
        </div>
        <div>

          <b-row>
            <b-col sm="12">
            <!-- Logo -->
              <b-form-group>
                <b-row>
                <b-col cols="12" sm="2" class="text-center">
                  <img @click="modalShow = true, previewModal = previewLogo" class="logo" :src="previewLogo" alt="Logo">
                </b-col>
                <b-col cols="12" sm="10" class="margin-top-20">
                <b-input-group>
                <div class="custom-file">
                    <input type="file" class="custom-file-input form-upload" @change="changeLogo">
                    <label class="custom-file-label"> {{ form.logo.name || 'choose logo image 350x350' }} </label>
                </div>
                <b-button variant="outline-secondary" @click="previewLogo = '/images/101/thumbnail.png'; form.logo = {}; form.defaultLogo = true">
                  Set Default
                </b-button>
                </b-input-group>
                </b-col>
                </b-row>
              </b-form-group>

              <!-- Cover -->
              <b-form-group>
                <b-row>
                <b-col cols="12" sm="2" class="text-center">
                  <img @click="modalShow = true, previewModal = previewCover" class="logo" :src="previewCover" alt="Cover">
                </b-col>
                <b-col cols="12" sm="10" class="margin-top-20">
                <b-input-group>
                <div class="custom-file">
                    <input type="file" class="custom-file-input form-upload" @change="changeCover">
                    <label class="custom-file-label"> {{ form.cover.name || 'choose cover image 1200x534' }} </label>
                </div>
                <b-button variant="outline-secondary" @click="previewCover = '/images/101/thumbnail.png'; form.cover = {}; form.defaultCover = true">
                  Set Default
                </b-button>
                </b-input-group>
                </b-col>
                </b-row>
              </b-form-group>

               <!-- Name -->
              <b-form-group>
                <label>Name</label>
                <b-input-group prepend="TH">
                    <b-input :state="feedback(fieldErrors.nameTH)" v-model="form.nameTH" placeholder="กรุณาใส่ชื่อภาษาไทย"></b-input>
                </b-input-group>
                <b-input-group prepend="EN">
                    <b-input :state="feedback(fieldErrors.nameEN)" v-model="form.nameEN" placeholder="please enter english name."></b-input>
                </b-input-group>
              </b-form-group>

              <!-- Details -->
              <b-form-group>
                <label>Details</label>
                <b-input-group prepend="TH">
                    <b-input v-model="form.detailTH" placeholder="กรุณาใส่รายละเอียดภาษาไทย"></b-input>
                </b-input-group>
                <b-input-group prepend="EN">
                    <b-input v-model="form.detailEN" placeholder="please enter english detail."></b-input>
                </b-input-group>
              </b-form-group>

              <!-- Zone -->
              <b-form-group>
              <label>Zones</label>
              <v-select :class="classSelect(fieldErrors.zoneId)"
                v-model="form.zones"
                :options="zones"
                :placeholder="'please select zone'">
              </v-select>
              </b-form-group>

              <!-- categories -->
              <b-form-group>
              <label>Categories</label>
              <v-select :class="classSelect(fieldErrors.categoriesId)"
               v-model="form.categories" multiple
               :options="categories"
               :placeholder="'please select category'"></v-select>
              </b-form-group>

              <!-- floors -->
              <b-form-group>
              <label>Floors</label>
              <v-select :class="classSelect(fieldErrors.floorId)"
              v-model="form.floors"
              :options="floors"
              :placeholder="'please select floor'"></v-select>
              </b-form-group>

              <!-- tiers -->
              <b-form-group>
              <label>Tiers</label>
              <v-select :class="classSelect(fieldErrors.tierId)"
              v-model="form.tiers"
              :options="tiers"
              :placeholder="'please select tiers'"></v-select>
              </b-form-group>

              <!-- Open date -->
              <b-form-group>
                <label>Open Date</label>
                <b-input v-model="form.openDate" placeholder="please enter open date."></b-input>
              </b-form-group>

            <!-- openTime - closetime -->
            <b-form-group>
            <label for="sendTo">Open - Close Time</label>
            <b-row class="ml-1">
                <autocomplete-vue
                :list="time"
                placeholder="open"
                inputClass="form-control"
                v-model="form.openTime"
            ></autocomplete-vue>
            <div class="fix-font"> To </div>
            <autocomplete-vue
                :list="time"
                placeholder="close"
                inputClass="form-control"
                v-model="form.closeTime"
            ></autocomplete-vue>
            </b-row>
            </b-form-group>

            <!-- Location -->
            <b-form-group>
                <label>Location</label>
                <b-input v-model="form.location" placeholder="please enter location."></b-input>
            </b-form-group>

              <!-- Contact -->
              <b-form-group>
              <label>contact</label>
              <b-input v-model="form.contact" placeholder="please enter contact."></b-input>
              </b-form-group>

            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <alert-success :show="successMessage != ''"> {{ successMessage }} </alert-success>
          <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>

          <b-button @click="$router.go(-1)" class="mr-2" size="sm" variant="secondary">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            Back
          </b-button>
          <b-button :disabled="!isActive" @click="save" class="mr-2" type="submit" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            Save
          </b-button>
          <b-button :disabled="!isActive" v-b-modal.confirmDelete v-if="$route.params.id" type="reset" size="sm" variant="danger">
            <i class="fa fa-ban"></i>
            Delete
          </b-button>
          <alert-confirm
            :id="'confirmDelete'"
            @confirm="confirmDelete">
            confirm to delete ?
          </alert-confirm>
          <b-modal centered hide-header hide-footer v-model="modalShow" body-class="text-center">
                <b-img fluid :src="previewModal" alt="image"></b-img>
          </b-modal>
        </div>
    </b-card>
    </div>
</template>

<script>
import AlertSuccess from '../../components/alert/AlertSuccess';
import AlertConfirm from '../../components/alert/AlertConfirm';
import Loading from '../../components/Loading';
import vSelect from 'vue-select';
import AutocompleteVue from 'autocomplete-vue';
import { timeAutoComplete } from '../../../src/assets/utils/time';
import { OptionList } from '../../models/option-list';

export default {
  data () {
    return {
      isLoading: '',
      successMessage: '',
      errorMessage: '',
      isActive: true,
      form: {
        logo: {},
        cover: {},
        nameTH: '',
        nameEN: '',
        detailTH: '',
        detailEN: '',
        zones: null,
        categories: [],
        floors: null,
        tiers: null,
        openDate: '',
        openTime: '',
        closeTime: '',
        location: '',
        contact: '',
        defaultLogo: true,
        defaultCover: true
      },
      previewLogo: '/images/101/thumbnail.png',
      previewCover: '/images/101/thumbnail.png',
      fieldErrors: {},
      zones: [],
      categories: [],
      floors: [],
      tiers: [],
      isLoadFinish: [],
      modalShow: false,
      previewModal: ''
    };
  },
  methods: {
    confirmDelete () {
      this.axios.delete(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/base/shops/' + this.$route.params.id)
        .then(response => {
          this.successMessage = 'delete shop finish!';
        })
        .catch(error => {
          this.isLoading = false;
          this.isActive = true;
          this.handleError(error);
        });
    },
    save () {
      const id = this.$route.params.id;
      this.isLoading = true;
      this.isActive = false;
      const formData = new FormData();
      formData.append('logo', this.form.logo);
      formData.append('cover', this.form.cover);
      formData.append('nameTH', this.form.nameTH);
      formData.append('nameEN', this.form.nameEN);
      formData.append('detailTH', this.form.detailTH);
      formData.append('detailEN', this.form.detailEN);
      formData.append('zoneId', this.form.zones ? this.form.zones.code : '');
      formData.append('categoriesId', this.form.categories.map(category => category.code).join(','));
      formData.append('floorId', this.form.floors ? this.form.floors.code : '');
      formData.append('tierId', this.form.tiers ? this.form.tiers.code : '');
      formData.append('openDate', this.form.openDate);
      formData.append('openTime', this.form.openTime);
      formData.append('closeTime', this.form.closeTime);
      formData.append('location', this.form.location);
      formData.append('contact', this.form.contact);
      formData.append('defaultLogo', this.form.defaultLogo);
      formData.append('defaultCover', this.form.defaultCover);

      if (id) { // update
        this.axios.patch(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/base/shops/' + id, formData)
          .then(response => {
            this.isLoading = false;
            this.successMessage = 'update shop finish!';
          })
          .catch(error => {
            this.isLoading = false;
            this.isActive = true;
            this.handleError(error);
          });
      } else { // create
        this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/base/shops', formData)
          .then(response => {
            this.isLoading = false;
            this.successMessage = 'create shop finish!';
          })
          .catch(error => {
            this.isLoading = false;
            this.isActive = true;
            this.handleError(error);
          });
      }
    },
    changeLogo (e) {
      const files = e.target.files || e.dataTransfer.files;
      this.form.logo = files[0];
      this.form.defaultLogo = false;
      this.previewLogo = URL.createObjectURL(this.form.logo);
    },
    changeCover (e) {
      const files = e.target.files || e.dataTransfer.files;
      this.form.cover = files[0];
      this.form.defaultCover = false;
      this.previewCover = URL.createObjectURL(this.form.cover);
    },
    getData () {
      this.setDefault();
      const id = this.$route.params.id;
      if (id) {
        this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + `/mqdc/base/shops/${id}`)
          .then(response => {
            const data = response.data.data;
            if (data) {
              const shop = data.shop;
              this.previewLogo = shop.logo || this.previewLogo;
              this.previewCover = shop.cover || this.previewCover;
              this.form = {
                logo: {},
                cover: {},
                nameTH: shop.nameTH,
                nameEN: shop.nameEN,
                detailTH: shop.detailTH,
                detailEN: shop.detailEN,
                zones: this.zones.find(zone => zone.code === shop.zone.id || ''),
                categories: shop.categories.map(value => this.categories.find(category => category.code === value.id)),
                floors: this.floors.find(floor => floor.code === shop.floor.id || ''),
                tiers: this.tiers.find(tier => tier.code === shop.tier.id || ''),
                openDate: shop.openDate,
                openTime: shop.openTime,
                closeTime: shop.closeTime,
                location: shop.location,
                contact: shop.contact
              };
            }
          })
          .catch(error => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    loadOptionList () {
      const optionList = new OptionList(this.axios);
      this.isLoadFinish = [];
      this.isLoading = true;
      optionList.loadZones()
        .then(response => {
          this.zones = response;
          this.isLoadFinish.push('zones');
        })
        .catch(error => {
          this.handleError(error);
        });
      optionList.loadCategories()
        .then(response => {
          this.categories = response;
          this.isLoadFinish.push('categories');
        })
        .catch(error => {
          this.handleError(error);
        });
      optionList.loadFloors()
        .then(response => {
          this.floors = response;
          this.isLoadFinish.push('floors');
        })
        .catch(error => {
          this.handleError(error);
        });
      optionList.loadTiers()
        .then(response => {
          this.tiers = response;
          this.isLoadFinish.push('tiers');
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    handleError (error) {
      this.fieldErrors = {};
      this.errorMessage = error.message;
      if (error.response) {
        this.errorMessage = error.response.data.message;
        const data = error.response.data.data;
        this.setFieldErrors(data);
      }
      this.isLoading = false;
    },
    setFieldErrors (fields) {
      if (fields) {
        for (const field of fields) {
          this.fieldErrors[field.param] = { message: field.msg, isCorrect: false };
        }
      }
    },
    setDefault () {
      this.form = {
        logo: {},
        cover: {},
        nameTH: '',
        nameEN: '',
        detailTH: '',
        detailEN: '',
        zones: null,
        categories: [],
        floors: null,
        tiers: null,
        openDate: '',
        openTime: '',
        closeTime: '',
        location: '',
        contact: '',
        defaultLogo: true,
        defaultCover: true
      };
      this.previewLogo = '/images/101/thumbnail.png';
      this.previewCover = '/images/101/thumbnail.png';
      this.errorMessage = '';
      this.fieldErrors = {};
    }
  },
  components: {
    AlertSuccess,
    AlertConfirm,
    'app-loading': Loading,
    'v-select': vSelect,
    'autocomplete-vue': AutocompleteVue
  },
  computed: {
    feedback () {
      return data => {
        if (!data) {
          return null;
        } else {
          return data.isCorrect;
        }
      };
    },
    classSelect () {
      return data => {
        if (!data) {
          return '';
        } else {
          return 'select-validate-fail';
        }
      };
    },
    time () {
      return timeAutoComplete();
    }
  },
  mounted () {
    // get options list
    this.loadOptionList();
  },
  watch: {
    '$route' (to, from) {
      this.getData();
    },
    isLoadFinish (to, form) {
      if (4 === this.isLoadFinish.filter(value =>
        'zones' === value ||
        'categories' === value ||
        'floors' === value ||
        'tiers' === value).length) {
        if (this.$route.params.id) {
          this.getData();
        }
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
    .logo{
      max-height: 75px;
      max-width: 100px;
      -webkit-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      margin-bottom: 5px;
    }
    .logo:hover{
        cursor: pointer;
    }
    .text-center{
        text-align: center;
    }
    .margin-top-20{
        margin-top: 20px;
    }
    .form-upload:hover {
        cursor: pointer;
    }
    .custom-file-label{
        overflow: hidden;
        white-space: nowrap;
    }
    .fix-font{
        margin-top: 8px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .autocomplete{
        width: 60px;
        text-align: center;
    }
    .autocomplete__entry{
        text-align: center;
    }
    .autocomplete__entry:hover{
        cursor: pointer;
    }
    .text-center{
        text-align: center;
    }
</style>

<style>
  .select-validate-fail .vs__search::placeholder,
  .select-validate-fail .vs__dropdown-toggle,
  .select-validate-fail .vs__dropdown-menu {
    border: 1px solid #f86c6b;
  }
</style>
